import JsPDF from "jspdf";
import moment from "moment";
import "./fonts/AlHurra Font Regular-normal"
import "./fonts/ArbFONTS-Alexandria-VariableFont_wght-normal"
import "./fonts/ArbFONTS-Sukar-Bold-1-normal"
import "./fonts/ArbFONTS-sultani-bold-normal"
import "./fonts/DroidSansArabic-normal"
import "./fonts/NotoKufiArabic-Bold-normal"
import "./fonts/NotoKufiArabic-Regular-normal"
import "./fonts/STC-Bold-normal"
import "./fonts/Tajawal-Bold-normal"
async function drawGrid(doc) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const gridSpacing = 20; // Spacing between grid lines in points

  // Draw vertical grid lines and label X-coordinates
  for (let x = 0; x <= pageWidth; x += gridSpacing) {
    doc.setDrawColor(200, 200, 200); // Light gray for grid lines
    if (x === 0) {
      // Highlight Y-axis
      doc.setDrawColor(0, 0, 255); // Blue
      doc.setLineWidth(0.8); // Thicker line for axis
    } else {
      doc.setLineWidth(0.2); // Regular line width
    }
    doc.line(x, 0, x, pageHeight); // Draw vertical line

    // Label X-coordinates
    doc.setFontSize(12);
    if (x > 0) {
      doc.text(String(x), x + 2, 10); // Place numbers near the top
    }
  }

  // Draw horizontal grid lines and label Y-coordinates
  for (let y = 0; y <= pageHeight; y += gridSpacing) {
    doc.setDrawColor(200, 200, 200); // Light gray for grid lines
    if (y === 0) {
      // Highlight X-axis
      doc.setDrawColor(255, 0, 0); // Red
      doc.setLineWidth(0.8); // Thicker line for axis
    } else {
      doc.setLineWidth(0.2); // Regular line width
    }
    doc.line(0, y, pageWidth, y); // Draw horizontal line

    // Label Y-coordinates
    doc.setFontSize(12);
    if (y > 0) {
      doc.text(String(y), 2, y - 2); // Place numbers near the left side
    }
  }
}
function hexToRgb(hex) {
  const bigint = parseInt(hex.slice(1), 16); // Remove "#" and parse the hex string
  return {
    r: (bigint >> 16) & 255, // Extract red
    g: (bigint >> 8) & 255, // Extract green
    b: bigint & 255, // Extract blue
  };
}

function drawOneCertificate(
  doc,
  studentData,
  configPrint,
  schoolarYearName,
  preview
) {
  try {
    let imageUrl = studentData.certifImgUrl;
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();
    doc.addImage(imageUrl, "PNG", 0, 0, width, height);
    if (preview) drawGrid(doc);
    const fontValue = configPrint.font;
    const [fontName, fontStyle] = fontValue.includes("-")
      ? fontValue.split("-")
      : [fontValue, "normal"];

    let fontSize = 23;
    doc.setFont(fontName, fontStyle);
    doc.setFontSize(fontSize);
    let { r, g, b } = hexToRgb(configPrint.fullName.color);

    doc.setTextColor(r, g, b);
    let text = studentData.fullName;
    doc.setFontSize(configPrint.fullName.fontSize);
    let xPositionName = configPrint.fullName.x;

    if (configPrint.xAlign == "center") {
      let fullNameWidth = doc.getTextWidth(text);

      xPositionName = configPrint.fullName.x - fullNameWidth / 2;
    }
    try {
      doc.text(text, xPositionName, configPrint.fullName.y, {
        rtl: true,
      });
    } catch (error) {
      console.warn("Skipping fullName rendering:", error.message);
    }
    //class name
    doc.setFontSize(configPrint.className.fontSize);
    ({ r, g, b } = hexToRgb(configPrint.className.color));
    doc.setTextColor(r, g, b);
    let xPositionClass = configPrint.className.x;

    if (configPrint.xAlign == "center") {
      let classroomNameWidth = doc.getTextWidth(studentData.classroomName);
      xPositionClass = configPrint.className.x - classroomNameWidth / 2;
    }

    try {
      doc.text(
        studentData.classroomName,
        xPositionClass,
        configPrint.className.y,
        {
          rtl: true,
        }
      );
    } catch (error) {
      console.warn("Skipping className rendering:", error.message);
    }
    //trimester name
    doc.setFontSize(configPrint.trimestre.fontSize);
    ({ r, g, b } = hexToRgb(configPrint.trimestre.color));
    doc.setTextColor(r, g, b);
    let xPositionTrimestre = configPrint.trimestre.x;

    if (configPrint.xAlign == "center") {
      let trimestreWidth = doc.getTextWidth(studentData.trimestre);
      xPositionTrimestre = configPrint.trimestre.x - trimestreWidth / 2;
    }
    if (studentData.trimestre === "1") {
      studentData.trimestre = "الأول";
    } else if (studentData.trimestre === "2") {
      studentData.trimestre = "الثاني";
    } else if (studentData.trimestre === "3") {
      studentData.trimestre = "الثالث";
    }

    try {
      doc.text(
        studentData.trimestre,
        xPositionTrimestre,
        configPrint.trimestre.y,
        {
          rtl: true,
        }
      );
    } catch (error) {
      console.warn("Skipping trimestre rendering:", error.message);
    }

    //school year name
    doc.setFontSize(configPrint.schoolYear.fontSize);
    ({ r, g, b } = hexToRgb(configPrint.schoolYear.color));
    doc.setTextColor(r, g, b);
    let xPositionSchoolYear = configPrint.schoolYear.x;

    if (configPrint.xAlign == "center") {
      let schoolYearWidth = doc.getTextWidth(schoolarYearName);
      xPositionSchoolYear = configPrint.schoolYear.x - schoolYearWidth / 2;
    }
    try {
      doc.text(schoolarYearName, xPositionSchoolYear, configPrint.schoolYear.y, {
        rtl: true,
      });
    } catch (error) {
      console.warn("Skipping schoolYear rendering:", error.message);
    }

    // Print Date
    if (configPrint.printDate && configPrint.printDate.enabled) {
      doc.setFontSize(configPrint.printDate.fontSize);
      ({ r, g, b } = hexToRgb(configPrint.printDate.color));
      doc.setTextColor(r, g, b);

      const dateFormat = configPrint.printDate.format || "DD/MM/YYYY";
      const formattedDate = configPrint.printDate.value
        ? moment(configPrint.printDate.value, "YYYY-MM-DD").format(dateFormat)
        : moment().format(dateFormat);
      const label = configPrint.printDate.label || "";

      let xPositionPrintDate = configPrint.printDate.x;

      if (label) {
        // Render label (Arabic/RTL) and date (LTR) as two separate calls so
        // each part keeps its own direction without Bidi reordering.
        const dateWidth = doc.getTextWidth(formattedDate);
        const spaceWidth = doc.getTextWidth(" ");
        const dateX = xPositionPrintDate;
        const labelX = dateX + dateWidth + spaceWidth;

        try {
          doc.text(formattedDate, dateX, configPrint.printDate.y, { rtl: false });
        } catch (error) {
          console.warn("Skipping printDate date rendering:", error.message);
        }
        try {
          doc.text(label, labelX, configPrint.printDate.y, { rtl: true });
        } catch (error) {
          console.warn("Skipping printDate label rendering:", error.message);
        }
      } else {
        if (configPrint.xAlign == "center") {
          xPositionPrintDate = configPrint.printDate.x - doc.getTextWidth(formattedDate) / 2;
        }
        try {
          doc.text(formattedDate, xPositionPrintDate, configPrint.printDate.y, { rtl: false });
        } catch (error) {
          console.warn("Skipping printDate rendering:", error.message);
        }
      }
    }

    // Stamp
    if (configPrint.stamp && configPrint.stamp.enabled && studentData.stampUrl) {
      try {
        const baseSize = 40; // Base size in mm
        const stampWidth = baseSize * (configPrint.stamp.scale || 1);
        const stampHeight = baseSize * (configPrint.stamp.scale || 1);

        doc.addImage(
          studentData.stampUrl,
          "PNG",
          configPrint.stamp.x,
          configPrint.stamp.y,
          stampWidth,
          stampHeight
        );
      } catch (error) {
        console.error("Error drawing stamp:", error);
      }
    }
  } catch (error) {
    console.log(error);
  }
}

//used in paramétrage for preview
const drawCertifcate = async (
  studentData,
  configPrint,
  certifImgUrl,
  schoolarYearName,
  preview = false
) => {
  try {
    const doc = new JsPDF({
      orientation: configPrint.orientation,
      unit: "mm",
      format: "a4",
    });
    studentData.certifImgUrl = certifImgUrl;
    await drawOneCertificate(
      doc,
      studentData,
      configPrint,
      schoolarYearName,
      preview
    );
    return doc;
    //end stamp
  } catch (error) {
    console.log(error);
  }
};

const drawAllCertificate = async (students, schoolarYearName) => {
  try {
    if (students.length === 0) return null;

    // Create a base document (we'll replace all pages anyway)
    const doc = new JsPDF({
      unit: "mm",
      format: "a4",
    });

    // Remove the first page that's automatically created
    doc.deletePage(1);

    // Process each student with their specific orientation
    students.forEach((student) => {
      const orientation = student.certificate?.configPrint?.orientation || 'portrait';

      // Add a new page with the student's orientation
      doc.addPage([210, 297], orientation);

      drawOneCertificate(
        doc,
        student,
        student.certificate?.configPrint,
        schoolarYearName
      );
    });
    return doc;
  } catch (error) {
    console.error(error);
  }
};
export { drawCertifcate, drawAllCertificate };
